import {
  FormEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";

import {
  BsDisplay,
  BsPencilSquare,
  BsPlusCircle,
  BsSave,
  BsSearch,
  
} from "react-icons/bs";

import InventarioService from "../../../Services/Catalogos/InventarioService";


import {
  DTOMonitorInventario,
  FiltroMonitores,
} from "../../../DTO/Inventario/DTOMonitorInventario";

import { DTOEstadoEquipo } from "../../../DTO/Inventario/DTOCatalogosInventario";
import { DTOGestionarMonitor } from "../../../DTO/Inventario/DTOGestionInventario";



interface MensajeVista {
  tipo: "success" | "danger";
  texto: string;
}

const crearFormulario = (): DTOGestionarMonitor => ({
  accion: "INSERTAR",
  idMonitor: null,
  idEstadoEquipo: null,
  serviceTagSerial: "",
  numEmpleadoAsignado: null,
  nombreResponsable: null,
  idEquipoRelacionado: null,
  observaciones: "",
});

const obtenerMensajeError = (error: unknown): string => {
  const errorAxios = error as {
    response?: {
      data?: {
        mensaje?: string;
      };
    };
    message?: string;
  };

  return (
    errorAxios.response?.data?.mensaje ??
    errorAxios.message ??
    "Ocurrió un error inesperado."
  );
};

const obtenerColorEstado = (estado?: string | null): string => {
  const estadoNormalizado = estado?.toLowerCase() ?? "";

  if (estadoNormalizado === "activo") return "success";
  if (estadoNormalizado.includes("reparación")) return "warning";
  if (estadoNormalizado.includes("reparacion")) return "warning";

  return "secondary";
};

const InventarioMonitores = () => {
  const [monitores, setMonitores] = useState<DTOMonitorInventario[]>([]);
  const [estados, setEstados] = useState<DTOEstadoEquipo[]>([]);

  const [filtro, setFiltro] =
    useState<FiltroMonitores>("TODOS");

  const [busqueda, setBusqueda] = useState("");
  const [cargando, setCargando] = useState(true);
  const [procesando, setProcesando] = useState(false);

  const [showFormulario, setShowFormulario] = useState(false);
  const [monitorEditar, setMonitorEditar] =
    useState<DTOMonitorInventario | null>(null);

  const [formulario, setFormulario] =
    useState<DTOGestionarMonitor>(crearFormulario);

  const [mensaje, setMensaje] =
    useState<MensajeVista | null>(null);

  const cargarDatos = useCallback(async () => {
    setCargando(true);
    setMensaje(null);

    try {
      const [respuestaMonitores, respuestaEstados] =
        await Promise.all([
        //   InventarioService.obtenerMonitores(filtro),
        InventarioService.obtenerMonitores("TODOS"),
          InventarioService.obtenerEstadosEquipo(),
        ]);

      setMonitores(respuestaMonitores.data);
      setEstados(respuestaEstados.data);
    } catch (errorPeticion) {
      setMensaje({
        tipo: "danger",
        texto: obtenerMensajeError(errorPeticion),
      });
    } finally {
      setCargando(false);
    }
//   }, [filtro]);
}, []);

  useEffect(() => {
    void cargarDatos();
  }, [cargarDatos]);

  const estadosPermitidos = useMemo(
    () =>
      estados.filter((estado) => {
        const nombre = estado.estado
          .trim()
          .toLowerCase();

        return (
          nombre !== "baja" &&
          nombre !== "donación/destrucción" &&
          nombre !== "donacion/destruccion"
        );
      }),
    [estados]
  );



  const totalMonitores = monitores.length;

const totalAsignados = monitores.filter(
  (monitor) =>
    monitor.idEquipoRelacionado !== null &&
    monitor.idEquipoRelacionado !== undefined
).length;

const totalSinAsignar = monitores.filter(
  (monitor) =>
    monitor.idEquipoRelacionado === null ||
    monitor.idEquipoRelacionado === undefined
).length;



    const monitoresFiltrados = useMemo(() => {
  const texto = busqueda.trim().toLowerCase();

  return monitores.filter((monitor) => {
    const cumpleSituacion =
      filtro === "TODOS" ||
      (
        filtro === "DISPONIBLES" &&
        monitor.disponible
      ) ||
      (
        filtro === "ASIGNADOS" &&
        monitor.idEquipoRelacionado !== null &&
        monitor.idEquipoRelacionado !== undefined
      );

    if (!cumpleSituacion) return false;

    if (!texto) return true;

    const contenido = [
      monitor.serviceTagSerial,
      monitor.estadoMonitor,
      monitor.equipoRelacionado,
      monitor.numEmpleadoAsignado,
      monitor.nombreEmpleado,
      monitor.nombreResponsable,
      monitor.observaciones,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return contenido.includes(texto);
  });
}, [busqueda, filtro, monitores]);





  

  const abrirNuevoMonitor = () => {
    const idEstadoActivo =
      estados.find(
        (estado) =>
          estado.estado.trim().toLowerCase() === "activo"
      )?.idEstadoEquipo ?? null;

    setMonitorEditar(null);
    setFormulario({
      ...crearFormulario(),
      accion: "INSERTAR",
      idEstadoEquipo: idEstadoActivo,
    });
    setShowFormulario(true);
  };

  const abrirEditarMonitor = (
    monitor: DTOMonitorInventario
  ) => {
    setMonitorEditar(monitor);
    setFormulario({
      accion: "ACTUALIZAR",
      idMonitor: monitor.idMonitor,
      idEstadoEquipo: monitor.idEstadoEquipo,
      serviceTagSerial: monitor.serviceTagSerial ?? "",
      numEmpleadoAsignado: null,
      nombreResponsable: null,
      idEquipoRelacionado: null,
      observaciones: monitor.observaciones ?? "",
    });
    setShowFormulario(true);
  };

  const cerrarFormulario = () => {
    if (procesando) return;

    setShowFormulario(false);
    setMonitorEditar(null);
    setFormulario(crearFormulario());
  };

  const guardarMonitor = async (
    event: FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    if (!formulario.idEstadoEquipo) {
      setMensaje({
        tipo: "danger",
        texto: "Selecciona el estado del monitor.",
      });
      return;
    }

    setProcesando(true);
    setMensaje(null);

    try {
      const respuesta =
        await InventarioService.gestionarMonitor({
          accion: monitorEditar
            ? "ACTUALIZAR"
            : "INSERTAR",

          idMonitor:
            monitorEditar?.idMonitor ?? null,

          idEstadoEquipo:
            formulario.idEstadoEquipo,

          serviceTagSerial:
            formulario.serviceTagSerial?.trim() || null,

          observaciones:
            formulario.observaciones?.trim() || null,

          // Los monitores nuevos siempre se registran en stock.
          idEquipoRelacionado: null,
          numEmpleadoAsignado: null,
          nombreResponsable: null,
        });

      setShowFormulario(false);
      setMonitorEditar(null);
      setFormulario(crearFormulario());

      setMensaje({
        tipo: "success",
        texto: respuesta.data.mensaje,
      });

      await cargarDatos();
    } catch (errorPeticion) {
      setMensaje({
        tipo: "danger",
        texto: obtenerMensajeError(errorPeticion),
      });
    } finally {
      setProcesando(false);
    }
  };

  return (
    <div>
      {mensaje && (
        <Alert
          variant={mensaje.tipo}
          dismissible
          onClose={() => setMensaje(null)}
        >
          {mensaje.texto}
        </Alert>
      )}

      <div
        className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3"
        style={{
          background: "#ffffff",
          padding: "14px 20px",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
        }}
      >
        <div className="d-flex align-items-center gap-3">
          <div
            className="d-flex align-items-center justify-content-center rounded-3"
            style={{
              width: 42,
              height: 42,
              color: "#2563eb",
              backgroundColor: "#eff6ff",
              border: "1px solid #dbeafe",
            }}
          >
            <BsDisplay size={20} />
          </div>

          <div>
            <div className="fw-bold">Inventario de monitores</div>
            <div
              className="text-muted"
              style={{ fontSize: 12 }}
            >
              Registro, stock y asignaciones
            </div>
          </div>
        </div>

        <Button
          variant="primary"
          onClick={abrirNuevoMonitor}
        >
          <BsPlusCircle className="me-2" />
          Registrar monitor
        </Button>
      </div>
                <Row className="g-3 mb-3">
  <Col xs={12} md={4}>
    <Card className="border-0 shadow-sm h-100">
      <Card.Body>
        <div className="text-muted small fw-semibold">
          Total de monitores
        </div>

        <div
          className="fw-bold mt-1"
          style={{ fontSize: 26 }}
        >
          {totalMonitores}
        </div>
      </Card.Body>
    </Card>
  </Col>

  <Col xs={12} md={4}>
    <Card className="border-0 shadow-sm h-100">
      <Card.Body>
        <div className="text-muted small fw-semibold">
          Monitores asignados
        </div>

        <div
          className="fw-bold text-primary mt-1"
          style={{ fontSize: 26 }}
        >
          {totalAsignados}
        </div>
      </Card.Body>
    </Card>
  </Col>

  <Col xs={12} md={4}>
    <Card className="border-0 shadow-sm h-100">
      <Card.Body>
        <div className="text-muted small fw-semibold">
          Monitores sin asignar
        </div>

        <div
          className="fw-bold text-success mt-1"
          style={{ fontSize: 26 }}
        >
          {totalSinAsignar}
        </div>
      </Card.Body>
    </Card>
  </Col>
</Row>












      <Card
        className="border-0 shadow-sm"
        style={{
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        <Card.Body className="p-0">
          <div
            className="p-3 bg-white"
            style={{
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <Row className="g-3">
              <Col xs={12} md={8}>
                <Form.Label className="small fw-semibold">
                  Buscar monitor
                </Form.Label>

                <div className="position-relative">
                  <BsSearch
                    className="position-absolute text-muted"
                    style={{
                      left: 12,
                      top: 12,
                    }}
                  />

                  <Form.Control
                    value={busqueda}
                    onChange={(event) =>
                      setBusqueda(event.target.value)
                    }
                    placeholder="Serial, equipo, empleado u observaciones..."
                    style={{
                      paddingLeft: 36,
                    }}
                  />
                </div>
              </Col>

              <Col xs={12} md={4}>
                <Form.Label className="small fw-semibold">
                  Situación
                </Form.Label>

                <Form.Select
                  value={filtro}
                  onChange={(event) =>
                    setFiltro(
                      event.target.value as FiltroMonitores
                    )
                  }
                >
                  <option value="TODOS">
                    Todos
                  </option>
                  <option value="DISPONIBLES">
                    Disponibles
                  </option>
                  <option value="ASIGNADOS">
                    Asignados
                  </option>
                </Form.Select>
              </Col>
            </Row>
          </div>

          {cargando ? (
            <div className="text-center py-5">
              <Spinner
                animation="border"
                variant="primary"
              />
              <div className="text-muted mt-2">
                Cargando monitores...
              </div>
            </div>
          ) : (
            <Table responsive hover className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="small">ID</th>
                  <th className="small">Serial</th>
                  <th className="small">Estado</th>
                  <th className="small">Situación</th>
                  <th className="small">Equipo</th>
                  <th className="small">Responsable</th>
                  <th className="small">Observaciones</th>
                  <th className="small text-center">
                    Acciones
                  </th>
                </tr>
              </thead>

              <tbody>
                {monitoresFiltrados.map((monitor) => (
                  <tr key={monitor.idMonitor}>
                    <td className="small">
                      {monitor.idMonitor}
                    </td>

                    <td className="font-monospace small">
                      {monitor.serviceTagSerial ?? "—"}
                    </td>

                    <td>
                      <Badge
                        bg={obtenerColorEstado(
                          monitor.estadoMonitor
                        )}
                      >
                        {monitor.estadoMonitor ?? "—"}
                      </Badge>
                    </td>

                    <td>
                      <Badge
                        bg={
                          monitor.disponible
                            ? "success"
                            : "primary"
                        }
                      >
                        {monitor.disponible
                          ? "Disponible"
                          : "Asignado"}
                      </Badge>
                    </td>

                    <td className="small">
                      {monitor.equipoRelacionado ?? "—"}
                    </td>

                    <td className="small">
                      {monitor.nombreEmpleado ??
                        monitor.nombreResponsable ??
                        "—"}

                      {monitor.numEmpleadoAsignado && (
                        <div className="text-muted">
                          #{monitor.numEmpleadoAsignado}
                        </div>
                      )}
                    </td>

                    <td className="small">
                      {monitor.observaciones ?? "—"}
                    </td>

                    <td className="text-center">
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        title="Editar monitor"
                        onClick={() =>
                          abrirEditarMonitor(monitor)
                        }
                      >
                        <BsPencilSquare />
                      </Button>
                    </td>
                  </tr>
                ))}

                {monitoresFiltrados.length === 0 && (
                  <tr>
                    <td
                      colSpan={8}
                      className="text-center text-muted py-5"
                    >
                      No se encontraron monitores.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      <Modal
        show={showFormulario}
        onHide={cerrarFormulario}
        centered
        backdrop="static"
      >
        <Form onSubmit={guardarMonitor}>
          <Modal.Header closeButton>
            <Modal.Title className="fs-5">
              <BsDisplay className="me-2 text-primary" />

              {monitorEditar
                ? "Editar monitor"
                : "Registrar monitor en stock"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            style={{ backgroundColor: "#f8fafc" }}
          >
            {!monitorEditar && (
              <Alert variant="info">
                El monitor se registrará como disponible.
                Podrás asignarlo posteriormente desde el
                detalle de un equipo.
              </Alert>
            )}

            <Row className="g-3">
              <Col xs={12}>
                <Form.Group>
                  <Form.Label className="small fw-semibold">
                    Estado
                    <span className="text-danger"> *</span>
                  </Form.Label>

                  <Form.Select
                    required
                    value={
                      formulario.idEstadoEquipo ?? ""
                    }
                    onChange={(event) =>
                      setFormulario((anterior) => ({
                        ...anterior,
                        idEstadoEquipo:
                          Number(event.target.value) ||
                          null,
                      }))
                    }
                  >
                    <option value="">
                      Seleccione un estado
                    </option>

                    {estadosPermitidos.map((estado) => (
                      <option
                        key={estado.idEstadoEquipo}
                        value={estado.idEstadoEquipo}
                      >
                        {estado.estado}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Form.Group>
                  <Form.Label className="small fw-semibold">
                    Service Tag / Serial
                  </Form.Label>

                  <Form.Control
                    value={
                      formulario.serviceTagSerial ?? ""
                    }
                    onChange={(event) =>
                      setFormulario((anterior) => ({
                        ...anterior,
                        serviceTagSerial:
                          event.target.value,
                      }))
                    }
                    placeholder="Serial del monitor"
                    maxLength={100}
                  />
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Form.Group>
                  <Form.Label className="small fw-semibold">
                    Observaciones
                  </Form.Label>

                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={
                      formulario.observaciones ?? ""
                    }
                    onChange={(event) =>
                      setFormulario((anterior) => ({
                        ...anterior,
                        observaciones:
                          event.target.value,
                      }))
                    }
                    placeholder="Marca, modelo, tamaño u otros datos..."
                    maxLength={500}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              disabled={procesando}
              onClick={cerrarFormulario}
            >
              Cancelar
            </Button>

            <Button
              type="submit"
              disabled={procesando}
            >
              {procesando ? (
                <>
                  <Spinner
                    size="sm"
                    animation="border"
                    className="me-2"
                  />
                  Guardando...
                </>
              ) : (
                <>
                  <BsSave className="me-2" />
                  Guardar monitor
                </>
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default InventarioMonitores;